import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class UserStatusInvalidError extends CodedError {
  static get errorName() {
    return errorCodes.userStatusInvalidError.code;
  }

  constructor(message: string = errorCodes.userStatusInvalidError.message) {
    super(message);
    this.code = errorCodes.userStatusInvalidError.code;
    this.message = `${message} ${errorCodes.userStatusInvalidError.code}`;
    this.name = errorCodes.userStatusInvalidError.name;
    this.status = 403;
  }
}
